module.exports = __webpack_public_path__ + "media/images/icons/flags/KP-0a0e8e9ee39a1b9673ce32b2517a6bb6.svg";